// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system-user-list[data-v-695ce44f]{\n  margin: 48px;\n  background-color: #fff;\n}\n.filter-container[data-v-695ce44f]{\n  text-align: right;\n  padding: 0 24px 24px;\n}\n.search-frame[data-v-695ce44f] {\n  width: 160px;\n  margin-left: 5px;\n}\n.search-btn[data-v-695ce44f] {\n  margin-left: 10px;\n}\n.add-btn[data-v-695ce44f]{\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
